import { useState, type ReactElement, type ReactNode } from 'react';

export type NoticeKind = 'success' | 'warning' | 'error' | 'info';

const STYLES: Record<NoticeKind, string> = {
  success: 'border-wpnotice-success',
  warning: 'border-wpnotice-warning',
  error: 'border-wpnotice-error',
  info: 'border-wpnotice-info',
};

/**
 * WP風のお知らせバー（指示書 §7-3）。
 * 操作後に画面上部へ出し、閉じられるようにする。
 */
export function Notice({
  kind = 'info',
  children,
  dismissible = true,
  onDismiss,
}: {
  kind?: NoticeKind;
  children: ReactNode;
  dismissible?: boolean;
  onDismiss?: () => void;
}): ReactElement | null {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div
      role={kind === 'error' ? 'alert' : 'status'}
      className={`mb-5 flex items-start justify-between gap-3 border-l-4 bg-white px-4 py-3 shadow-sm ${STYLES[kind]}`}
    >
      <div className="text-wptext">{children}</div>
      {dismissible && (
        <button
          type="button"
          aria-label="このお知らせを閉じる"
          onClick={() => {
            setVisible(false);
            onDismiss?.();
          }}
          className="shrink-0 rounded-sm px-1 text-wptext-muted hover:text-wptext-strong"
        >
          ×
        </button>
      )}
    </div>
  );
}
